import { pushDataLayer } from "../../../Shared/utils/datalayer";
import { CollectionType } from "../../custom_api/bookarang/types"
import { inspirationLabelsWeb } from "./Inspiration/Shared/InspirationBaseSelector"

export const pushAanZetDataLayer = (data: { category: string; action: string; label: string }) =>
  pushDataLayer({ ...data, event: 'aanzet-event' })

export const pushLocationEvent = (d: {[key: string]: string} ) => 
  pushDataLayer({ event: 'aanzet-event', category: 'Location', ...d})

export const pushExpand = (label: string) => 
  pushAanZetDataLayer({category: 'Location', action: 'Unfold', label: label})

export const pushTag = (action: string) => 
  pushAanZetDataLayer({category: 'Activity tag', action, label: window.location.pathname})

export const pushMembership = (membershipCategory: string, label: string) =>
  pushAanZetDataLayer({category: `Lidmaatschap ${membershipCategory.toLocaleLowerCase()}`, action: "lidmaatschap-"+label.toLowerCase(), label: ""})

export const pushMainMenu = (label: string) =>
  pushAanZetDataLayer({ category: 'Hoofdmenu', action: 'hoofdmenu-'+label.toLowerCase().split(' ').join(''), label: label })

export const pushSecondaryMenu = (label: string) =>
  pushAanZetDataLayer({ category: "Secundair menu", action: 'secundairmenu-'+label.toLowerCase().split(' ').join(''), label: label })

export const pushVenueMembership = () =>
  pushAanZetDataLayer({ category: "Vestigingspagina per stad", action: 'bekijk-abonnement', label: 'Openklapper lid worden' })

export const pushFooterMembership = () =>
  pushAanZetDataLayer({ category: "Footer", action: "footer-wordlid", label: "Lid worden" })

export const pushMobileMainMenu = (label: string) =>
  pushAanZetDataLayer({ category: "Mobiel hoofdmenu", action: 'menu-mobiel-'+label.toLowerCase().split(' ').join(''), label: label })

export const pushMobileSecondaryMenu = (label: string) =>
  pushAanZetDataLayer({ category: "Mobiel secundair menu", action: 'secundairmenu-mobiel-'+label.toLowerCase().split(' ').join(''), label: label })

export const pushActivityFilter = (filter: string, label: string) =>
  pushAanZetDataLayer({ category: 'Activiteiten', action: `activiteiten-filter-${filter}`, label: `${filter} - ${label}` })

export const pushActivitySearch = (query: string) =>
  pushAanZetDataLayer({ category: 'Activiteiten', action: `activiteiten-filter-text`, label: `${query.trim().toLowerCase().replace(/\s+/g, ' ')}` })

export const pushCtaBlockAction = (title: string, type: string, label: string) =>
  pushAanZetDataLayer({ category: `CTA: ${title}`, action: `cta-action-${type}`, label: label })

export const pushInspirationAction = (collection: CollectionType, action: string, label: string) => pushDataLayer({ event: 'AanZet Inspiratie', category: inspirationLabelsWeb[collection], action, label})

export const pushThemeBasedInspirationAction = (action: string, label: string = null) => pushInspirationAction('theme', action, label)

export const pushMoodBasedInspirationAction = (action: string, label: string = null) => pushInspirationAction('mood', action, label)

export const pushBookBasedInspirationAction = (action: string, label: string = null) => pushInspirationAction('book', action, label)

export const pushLocationBasedInspirationAction = (action: string, label: string = null) => pushInspirationAction('location', action, label)

export const pushBuildingBlockAction = (clickText: string) => pushAanZetDataLayer({ category: 'Bouwblok', action: window.location.pathname, label: clickText })

export const pushLocationSelectionAction = (location: string) => pushAanZetDataLayer({ category: "Localization", action: "select-prefered-location", label: location })